import { css } from '@/styled-system/css';

export const statisticsComponentStyles = css.raw({
  flexGrow: 3,
  minHeight: '140px',
  textAlign: 'center',
  overflow: 'hidden',
  '& .ResponsiveContainer-BarChart': {
    marginBottom: '200',
    height: '70px !important',
    pointerEvents: 'none',
  },
});
